"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yellowPalette = void 0;
var tempusYellow = '#FFC651';
var yellowPalette = {
  // TODO Possibly deprecating this color in v3, talk with Sarah W.
  yellowDark: '#F4B73B',
  yellow: tempusYellow,
  tempusYellow: tempusYellow,
  yellowLight: '#FFE2A7',
  yellowLightest: '#FFF6E4'
};
exports.yellowPalette = yellowPalette;